var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn btn-warning btn-sm",attrs:{"href":_vm.link}},[_vm._v("Permisos")])])
}
var staticRenderFns = []

export { render, staticRenderFns }